import React, { useState } from 'react';

import { Box, Card, Typography, IconButton, Button, Modal } from '@mui/material';
import { Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function GroupFormationCard(props) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const modalStyle = {
        position: 'absolute',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        width: "350px",
        boxShadow: 24,
        padding: 20,
        borderRadius: 5,
    };

    const deleteRun = () =>{
        props.handleDelete(props.savedGroups);
        handleClose();
    }

    const handleLoad = () => {
        props.loadSavedGroups(props.savedGroups.run_id);
    }

    return (
        <Card style={{width: "200px"}}>
            <Box sx={{px: 2, py: 1, backgroundColor: "#ECF7FF"}}>
            <Typography>{props.savedGroups.run_name != '' ? props.savedGroups.run_name : 'No Name'}</Typography>
                <Stack direction="row" justifyContent="space-between">
                    <Stack>
                        <Typography>1st</Typography>
                        <Typography>{props.savedGroups.first_percent}%</Typography>
                    </Stack >
                    <Stack>
                        <Typography>2nd</Typography>
                        <Typography>{props.savedGroups.second_percent}%</Typography>
                    </Stack>
                    <Stack>
                        <Typography>3rd</Typography>
                        <Typography>{props.savedGroups.third_percent}%</Typography>
                    </Stack>
                </Stack>
                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                    <Button variant="outlined" size="small" onClick={handleLoad}>Load</Button>
                    <IconButton aria-label="delete" onClick={handleOpen}>
                        <DeleteIcon />
                    </IconButton>
                    <Modal
                        open={open}
                        onClose={handleClose}
                    >
                        <Stack style={modalStyle} spacing={3}>
                            <Typography align='center'>Are you sure you want to delete this result?</Typography>
                            <Stack direction="row" justifyContent="center" spacing={5}>
                                <Button onClick={handleClose}>No</Button>
                                <Button onClick={deleteRun} variant="contained" color="primary">Yes</Button>
                            </Stack>
                        </Stack>
                    </Modal>
                </Stack>
            </Box>
        </Card>
    );
}

export default GroupFormationCard; 
